export const HamburgerIcon =
  "https://img.icons8.com/ios-filled/50/menu--v6.png";

export const YoutubeIcon =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlHMUb8U4VeW2y-RflH7U7Yp0tsx1hJv0PwQ&usqp=CAU";

export const SearchIcon = "http://img.icons8.com/ios-glyphs/30/search--v1.png";

export const MicIcon =
  "https://img.icons8.com/material-sharp/24/microphone--v1.png";

export const UserIcon =
  "https://img.icons8.com/puffy-filled/32/experimental-user-puffy-filled.png";

export const SEND_ICON = "https://img.icons8.com/windows/32/sent.png";

export const HOME_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/home--v1.png";

export const SHORTS_ICON =
  "https://img.icons8.com/material-outlined/24/youtube-shorts.png";

export const LIVE_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/rfid-signal.png";

export const SUB_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/video-playlist.png";

export const HISTORY_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/time-machine--v1.png";

export const WATCH_LATER_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/clock--v3.png";

export const LIKE_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/facebook-like--v1.png";

export const TRENDING_ICON =
  "https://img.icons8.com/windows/32/fire-element.png";

export const SHOPPING_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/shopping-bag.png";

export const MUSIC_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/music.png";

export const FILMS_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/clapperboard.png";

export const GAME_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/controller.png";

export const TROPHY_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/trophy--v1.png";

export const NEWS_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/newspaper-.png";

export const BULB_ICON =
  "https://img.icons8.com/fluency-systems-regular/48/light-on--v1.png";

export const UTUBE_ICON = "https://img.icons8.com/fluency/48/youtube-play.png";

export const UTUBE_MUSIC =
  "https://img.icons8.com/fluency/48/youtube-music.png";

export const UTUBE_TV = "https://img.icons8.com/doodle/48/youtube-tv.png";
